// components/NoAvailableData.tsx
import React, { FC } from 'react';
import { Box, Typography , Button} from '@mui/material';
import { ImgBox, Typography700 } from 'views/common/components';
import StyledBox from 'views/rebranded-module/common/components/UI/NoAvailableData/NoAvailableData.styles';

interface NoAvailableDataProps {
  title: string;
  description?: string;
  children?: React.ReactNode;
  bgColor?: string;
  handleClick?: () => void;
  buttonText?: string;
  icon?: string
}

const NoAvailableData: FC<NoAvailableDataProps> = (props) => {
  const {
    title, description, children, bgColor,handleClick, buttonText,icon
  } = props;
  return (
    <StyledBox bgcolor={bgColor}>
      <Box display="flex" flexDirection="column" alignItems="center" textAlign="center" gap={2}>
        <ImgBox
          image={{
            src: icon ||'/imgs/Rebranding/common/no-bike-available.png',
            alt: 'No available bikes',
          }}
          imgWidth="112px !important"
          imgHeight={112}
      />
        <Typography700 variant="h7" component="p" pt={2} >
          {title}
        </Typography700>
        {description && (
        <Typography variant="body3" color="text.secondary" dangerouslySetInnerHTML={{ __html: description }} />
        )}
        {handleClick && (
          <Button color="primary" variant="outlined" onClick={handleClick} className='NADButton' >
            {buttonText}
          </Button>
        )}
        {children}
      </Box>
    </StyledBox>
  );
};

export { NoAvailableData };